import type { TestResults } from '../../types';

/**
 * Convert the application's TestResults shape into a generic results map
 * acceptable to GraphAdapter implementations.
 *
 * This provides a single place to handle legacy shapes and avoids unsafe casts.
 */
export function convertTestResultsToGraphResults(testResults: TestResults | any): { [key: string]: any[] } {
    const out: { [key: string]: any[] } = {};

    if (!testResults) return out;

    // Common shape: object with keys 'both', 'left', 'right' (arrays)
    if (typeof testResults === 'object' && !Array.isArray(testResults)) {
        if (Array.isArray((testResults as any).both)) out.both = (testResults as any).both;
        if (Array.isArray((testResults as any).left)) out.left = (testResults as any).left;
        if (Array.isArray((testResults as any).right)) out.right = (testResults as any).right;

        // If the object doesn't have ear keys but is itself an array-like object, try to treat it as 'both'
        const keys = Object.keys(testResults);
        const hasEarKeys = keys.includes('both') || keys.includes('left') || keys.includes('right');
        if (!hasEarKeys) {
            // Flatten any numeric keys or array-like into 'both'
            if (Array.isArray((testResults as any))) {
                out.both = (testResults as any);
            }
        }

        return out;
    }

    // If it's an array (legacy), place it under 'both'
    if (Array.isArray(testResults)) {
        out.both = testResults as any[];
        return out;
    }

    // Fallback: wrap in 'both' as last resort
    out.both = [testResults] as any[];
    return out;
}